import { useState, useEffect } from "react";
import "./Cookies.css";
import Cookies from "js-cookie";

const expiresInDays = 365;
const lastUpdatedAgreement = "1739736000";

const cookiesAcceptedKey = "cookies_agreement";
const cookiesAcceptedValue = lastUpdatedAgreement;

const CookiesPopup = () => {
  const [isVisible, setIsVisible] = useState(() => {
    const storedCookie = Cookies.get(cookiesAcceptedKey);
    return storedCookie !== cookiesAcceptedValue;
  });


  useEffect(() => {
    const storedCookie = Cookies.get(cookiesAcceptedKey);
    if (storedCookie === cookiesAcceptedValue) {
      setIsVisible(false);
    }
  }, []);

  const acceptAgreement = () => {
    Cookies.set(cookiesAcceptedKey, cookiesAcceptedValue, { path: "/", expires: expiresInDays });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookies-popup">
      <button className="cookies-close" onClick={acceptAgreement}>&times;</button>
      <p className="cookies-text">
        Используя данный сайт, вы даете согласие на использование файлов{' '}
        <a
          href="https://melannett.ru/terms-conditions/"
          className="cookies-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          cookies
        </a>
        , помогающих нам сделать его удобнее для вас.
      </p>
      <button onClick={acceptAgreement} className="cookies-button">
        Хорошо
      </button>
    </div>
  );
};

export default CookiesPopup;
